import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_FINANCE_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

import {
  ADMIN_AVAILABLE_PAYMENT_SYSTEMS_LIST_ROUTE_NAME,
  ADMIN_AVAILABLE_PAYMENT_SYSTEMS_ROUTE_NAME,
  ADMIN_PAYMENT_SYSTEMS_PERMISSIONS,
  TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_SYSTEMS,
} from './constants';
import { AdminPaymentCountryGroupsModule } from './submodules/country-groups/AdminPaymentCountryGroupsModule';
import { getTranslationKeys } from './translations';

export class AdminAvailablePaymentSystemsModule extends AppModule {
  protected submodules = [
    new AdminPaymentCountryGroupsModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_AVAILABLE_PAYMENT_SYSTEMS_ROUTE_NAME,
      path: 'payment-systems',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AdminAvailablePaymentSystemsPage',
      permission: ADMIN_PAYMENT_SYSTEMS_PERMISSIONS.PAYMENTSYSTEMLISTS_SHOW,
    });

    router.addChildRoute(ADMIN_AVAILABLE_PAYMENT_SYSTEMS_ROUTE_NAME, {
      name: ADMIN_AVAILABLE_PAYMENT_SYSTEMS_LIST_ROUTE_NAME,
      path: '',
      permission: ADMIN_PAYMENT_SYSTEMS_PERMISSIONS.PAYMENTSYSTEMLISTS_SHOW,
      component: () => import('./pages/AdminAvailablePaymentSystemsPage/AdminAvailablePaymentSystemsPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_FINANCE_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'FINANCE_AVAILABLE_PAYMENT_SYSTEMS'),
      to: {
        name: ADMIN_AVAILABLE_PAYMENT_SYSTEMS_LIST_ROUTE_NAME,
      },
      permission: ADMIN_PAYMENT_SYSTEMS_PERMISSIONS.PAYMENTSYSTEMLISTS_SHOW,
      id: ADMIN_AVAILABLE_PAYMENT_SYSTEMS_LIST_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_SYSTEMS, getTranslationKeys);
  }
}
